export const slugStructureForLinking = ({ baseUrl, rewardId, slug }: { baseUrl: string; rewardId: string; slug?: string }): string => {
  const slugHyphenRewardId = `${slug}-${rewardId}`
  return `/virgin-red${baseUrl}/${slug ? slugHyphenRewardId : rewardId}`
}
